import { useField } from 'formik';
import { CountryCodeSelect } from './DialCodeSelect';
import styles from './styles.module.scss';
// import { inputWrapper, formlabel, phoneInput, errorSpan, phoneInline, required_text } from './styles.module.scss';

const FormikPhoneInputElement = props => {
  const [field, meta] = useField(props);
  const { dialcodename, dialcodevalue } = props;

  return (
    <div className={styles.inputWrapper}>
      <label className={styles.formlabel} htmlFor="Phone Number">
        Phone Number {props.requiredtext === 'true' ? <span className={styles.required_text}>*</span> : null}
        {props.required ? <span className={styles.required_text}>*</span> : null}
      </label>
      <div className={styles.phoneInline}>
        <CountryCodeSelect
          {...{
            dialcodename,
            dialcodevalue
          }}
        />
        <input
          className={styles.phoneInput}
          placeholder="901 2345 678"
          type="tel"
          maxLength="11"
          pattern="^[0-9]*$"
          title="Provide a valid phone number"
          autoComplete="tel"
          {...field}
          {...props}
        />
      </div>
      {meta.touched && meta.error ? <span className={styles.errorSpan}>{meta.error}</span> : null}
    </div>
  );
};


export default FormikPhoneInputElement;
